import { campaignQueryKeys } from "./queryKeys"
import { useCampaignQuery } from "./useCampaignQuery"

export function useCampaigns(params = {}, config = { enabled: true }) {
    const url = `campaigns/`
    const queryKey = campaignQueryKeys["list"](params)
    const { enabled = true } = config

    return useCampaignQuery(
        url,
        queryKey,
        params,
        {
            ...config,
            enabled: enabled,
        },
    )
}

export function useCampaign(
    id: string,
    params: Record<string, unknown> = {},
    config?: Record<string, unknown>,
) {
    const url = `campaigns/${id}/`
    const queryKey = campaignQueryKeys["detail"](id, params)

    return useCampaignQuery(
        url,
        queryKey,
        params,
        {
            ...config,
            enabled: !!id,
        },
    )
}
